import {Directive, ElementRef, HostListener, Input, OnInit} from '@angular/core';

/**
 * Apply this directive to any input to allow users to enter any text apart from text that matches the given regex.
 */
@Directive({
    standalone: true,
    selector: '[nlrPatternExcludeParser]'
})
export class NlrPatternExcludeParserDirective implements OnInit {
    @Input('nlrPatternExcludeParser') pattern: string;

    private re!: RegExp;

    constructor(private el: ElementRef) {}

    ngOnInit() {
        if (this.pattern) {
            this.re = new RegExp(this.pattern);
        }
    }

    @HostListener('input') onInputChange(): void {
        const input = this.el.nativeElement as HTMLInputElement;
        if (this.re.test(input.value)) {
            input.value = input.value.replace(this.re, '');
        }
    }
}
